import { getRecordingDataFromDB, RecordingData, saveRecordingDataToDB } from "@/utils/indexedDBUtils";
import { emitRecordingLocalStateUpdated } from "./recordingLocalStateEvents";

export type RecordingLocalState = RecordingData;

export const getRecordingLocalState = async (recordingUUID: string): Promise<RecordingLocalState | null> => {
  return getRecordingDataFromDB(recordingUUID);
};

export const saveRecordingLocalState = async (recordingData: RecordingLocalState): Promise<void> => {
  await saveRecordingDataToDB(JSON.stringify(recordingData));
  emitRecordingLocalStateUpdated(recordingData.recordingUUID);
};
